import { AppSidebar } from "@/components/app-sidebar";
import { NavbarItems } from "@/components/nav-main";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { Toaster } from "@/components/ui/toaster";
import { createRootRoute, Outlet } from "@tanstack/react-router";
import {
  BookOpen,
  BookUser,
  Building2,
  CalendarRange,
  ConciergeBell,
  Globe,
  HardHat,
  Home,
  Hotel,
  MapPin,
  MoreHorizontal,
  PersonStanding,
  User,
  Waypoints,
} from "lucide-react";

export const Route = createRootRoute({
  component: Root,
});

const items: NavbarItems = [
  {
    icon: <Home />,
    title: "home.title",
    url: "/",
  },
  {
    icon: <ConciergeBell />,
    title: "services.title",
    url: "/services",
  },
  {
    icon: <User />,
    title: "providers.title",
    url: "/providers",
  },
  {
    icon: <PersonStanding />,
    title: "guides.title",
    url: "/guides",
  },
  {
    icon: <HardHat />,
    title: "workers.title",
    url: "/workers",
  },
  {
    icon: <Building2 />,
    title: "agencies.title",
    url: "/agencies",
  },
  {
    icon: <Waypoints />,
    title: "tours.title",
    url: "/tours",
  },
  {
    icon: <Hotel />,
    title: "hotels.title",
    url: "/hotels",
  },
  {
    icon: <CalendarRange />,
    title: "reservations.calendar.title",
    url: "/reservations/calendar",
  },
  {
    icon: <BookOpen />,
    title: "reservations.title",
    url: "/reservations",
  },
  {
    icon: <MoreHorizontal />,
    title: "more.title",
    items: [
      {
        icon: <MapPin />,
        title: "regions.title",
        url: "/regions",
      },
      {
        icon: <BookUser />,
        title: "departments.title",
        url: "/departments",
      },
      {
        icon: <Globe />,
        title: "operations.title",
        url: "/operations",
      },
    ],
  },
];

function Root() {
  return (
    <>
      <SidebarProvider>
        <AppSidebar items={items} />
        <SidebarInset>
          <Outlet />
          <Toaster />
        </SidebarInset>
      </SidebarProvider>
    </>
  );
}
